import React from "react";

import Button from 'components/Safra/Button'
import { useTranslation } from "contexts/Safra/TranslationContext";

import { ContentNotFound } from './styles'

export const BoxNotFound = ({ text1, text2, handleClick }) => {
    const { t } = useTranslation();
    return (
        <ContentNotFound>
            <div className="row m-5">
                <div className="col-12">
                    <h5 className="fw-bolder fs-5 label">{text1}</h5>
                    {text2 && <p className="m-0 color-disabled">{text2}</p>}
                    {text2 && <p className="color-disabled">{t('safra.components.not_found.try_again')}</p>}
                </div>
            </div>
        </ContentNotFound>
    )
}

export const NotFoundResultsPassage = ({ handleInfo }) => {
    const { t } = useTranslation();
    return (
        <BoxNotFound
            handleClick={handleInfo}
            text1={t('safra.components.not_found.none_found')}
        />
    )
}

export const NotFoundResultsHotel = ({ handleInfo }) => {
    const { t } = useTranslation();
    return (
        <BoxNotFound
            handleClick={handleInfo}
            text1={t('safra.components.not_found.hotel_not_found')}
            text2={t('safra.components.not_found.hotel_none_found')}
        />
    )
}

export const NotFoundResultsCars = ({ handleInfo }) => {
    const { t } = useTranslation();
    return (
        <BoxNotFound
            handleClick={handleInfo}
            text1={t('safra.components.not_found.car_not_found')}
            text2={t('safra.components.not_found.car_none_found')}
        />
    )
}
